import { useInfiniteQuery } from '@tanstack/react-query';

import { client } from '@/api/common';
import type { Payout } from '@/api/reservations';

type Variables = {
  startDatetime?: string;
  endDatetime?: string;
  text?: string;
  enabled?: boolean;
};

type PayoutsPage = {
  data: Payout[];
  meta: {
    page: number;
    totalPages: number;
    totalCount: number;
  };
};

const fetchPayouts = async ({
  pageParam,
  variables,
}: {
  pageParam: number;
  variables: Variables;
}) => {
  try {
    let params: Record<string, any> = {};

    if (variables.startDatetime) {
      params.start_datetime = variables.startDatetime;
    }

    if (variables.endDatetime) {
      params.end_datetime = variables.endDatetime;
    }

    if (variables.text) {
      params.text = variables.text;
    }

    params.page = pageParam;

    const response = await client.get('v2/payouts', {
      params: { ...params },
    });

    return response.data;
  } catch (error) {
    console.error('fetchPayouts error:', error);
    throw error;
  }
};

export const usePayouts = (variables: Variables) => {
  const { enabled = true, ...queryVariables } = variables;

  return useInfiniteQuery({
    queryKey: ['payouts', queryVariables],
    queryFn: ({ pageParam = 1 }) =>
      fetchPayouts({
        pageParam,
        variables: queryVariables,
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage: PayoutsPage) => {
      if (lastPage.meta.page >= lastPage.meta.totalPages) {
        return undefined;
      }
      return lastPage.meta.page + 1;
    },
    enabled: enabled,
  });
};
